(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-bouquets"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-home-addons-slider]').forEach((slider) => {
    const row = slider.querySelector('[data-home-addons-row]');
    const prev = slider.querySelector('[data-home-addons-prev]');
    const next = slider.querySelector('[data-home-addons-next]');

    if (!row || !prev || !next) return;

    const scrollByPage = (direction) => {
      const distance = Math.max(240, row.clientWidth * 0.82);
      row.scrollBy({ left: distance * direction, behavior: 'smooth' });
    };

    prev.addEventListener('click', () => scrollByPage(-1));
    next.addEventListener('click', () => scrollByPage(1));

    // Tells the stylesheet which side still has cards to scroll to, so a themed
    // look can fade that edge only. The regular design does not use these classes.
    const syncEdges = () => {
      const max = row.scrollWidth - row.clientWidth;
      slider.classList.toggle('can-prev', row.scrollLeft > 4);
      slider.classList.toggle('can-next', row.scrollLeft < max - 4);
    };
    row.addEventListener('scroll', syncEdges, { passive: true });
    window.addEventListener('resize', syncEdges);
    window.addEventListener('load', syncEdges);
    syncEdges();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-featured-family-grid]').forEach((featuredGrid) => {
      const moreGrid = featuredGrid.parentElement.querySelector('[data-featured-family-more-grid]');
      if (!moreGrid) return;
      const ninthCard = featuredGrid.children[8];
      if (!ninthCard) return;
      const desktopAnchor = document.createComment('featured-nine-anchor');
      featuredGrid.insertBefore(desktopAnchor, ninthCard);
      const media = window.matchMedia('(max-width: 749px)');
      const syncFeaturedCount = () => {
        if (media.matches) moreGrid.insertBefore(ninthCard, moreGrid.firstElementChild);
        else featuredGrid.insertBefore(ninthCard, desktopAnchor.nextSibling);
      };
      syncFeaturedCount();
      media.addEventListener?.('change', syncFeaturedCount);
    });

    document.querySelectorAll('[data-price-filter]').forEach((form) => {
      const minRange = form.querySelector('[data-price-min-range]');
      const maxRange = form.querySelector('[data-price-max-range]');
      const minInput = form.querySelector('[data-price-min-input]');
      const maxInput = form.querySelector('[data-price-max-input]');
      const output = form.querySelector('[data-price-output]');
      const sliders = form.querySelector('.collection-price-filter__sliders');
      if (!minRange || !maxRange || !minInput || !maxInput || !sliders) return;

      const clamp = (value, min, max) => Math.min(max, Math.max(min, Number(value) || 0));
      const sync = (source) => {
        const maxAllowed = Math.max(1, Number(maxRange.max) || 0);
        let min = source === minInput ? clamp(minInput.value, 0, maxAllowed) : Number(minRange.value);
        let max = source === maxInput ? clamp(maxInput.value || maxAllowed, 0, maxAllowed) : Number(maxRange.value);
        if (min > max) source === minRange || source === minInput ? max = min : min = max;
        minRange.value = min;
        maxRange.value = max;
        minInput.value = min > 0 ? Math.round(min) : '';
        maxInput.value = max < maxAllowed ? Math.round(max) : '';
        sliders.style.setProperty('--price-min', `${(min / maxAllowed) * 100}%`);
        sliders.style.setProperty('--price-max', `${(max / maxAllowed) * 100}%`);
        if (output) output.textContent = `$${Math.round(min)} - $${Math.round(max)}`;
      };
      [minRange, maxRange, minInput, maxInput].forEach((control) => control.addEventListener('input', () => sync(control)));
      sync();
    });

    const openButton = document.querySelector('[data-collection-filter-open]');
    const panel = document.querySelector('[data-collection-filter-panel]');
    const closeButtons = document.querySelectorAll('[data-collection-filter-close]');
    if (!openButton || !panel) return;

    const mobileQuery = window.matchMedia('(max-width: 980px)');

    const syncPanelMode = () => {
      const mobile = mobileQuery.matches;
      if (mobile) {
        panel.setAttribute('role', 'dialog');
        panel.setAttribute('aria-modal', 'true');
        panel.setAttribute('aria-hidden', String(!panel.classList.contains('is-open')));
      } else {
        panel.removeAttribute('role');
        panel.removeAttribute('aria-modal');
        panel.removeAttribute('aria-hidden');
      }
    };

    const setOpen = (open) => {
      if (open && !mobileQuery.matches) return;
      panel.classList.toggle('is-open', open);
      document.body.classList.toggle('df-collection-filter-open', open);
      openButton.setAttribute('aria-expanded', String(open));
      panel.setAttribute('aria-hidden', String(!open));
      if (open) panel.querySelector('[data-collection-filter-close]')?.focus();
      else openButton.focus();
    };

    openButton.addEventListener('click', () => setOpen(true));
    closeButtons.forEach((button) => button.addEventListener('click', () => setOpen(false)));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && panel.classList.contains('is-open')) setOpen(false);
    });
    window.addEventListener('resize', () => {
      if (!mobileQuery.matches && panel.classList.contains('is-open')) setOpen(false);
      syncPanelMode();
    }, { passive: true });
    syncPanelMode();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oahu-delivery-landing"] && !Shopify.designMode) return;
  try {
    
  const initOahuDeliveryLanding = (landing) => {
    if (landing.dataset.oahuInitialized === 'true') return;
    landing.dataset.oahuInitialized = 'true';

    const campaignParams = new URLSearchParams();
    new URLSearchParams(window.location.search).forEach((value, key) => {
      const normalizedKey = String(key).toLowerCase();
      if (/^utm_/i.test(key) || ['gclid', 'gbraid', 'wbraid'].includes(normalizedKey)) campaignParams.append(key, value);
    });
    if ([...campaignParams].length) {
      landing.querySelectorAll('.product-card a[href], [data-oahu-preserve-query]').forEach((link) => {
        if (!link.href || link.getAttribute('href').startsWith('#')) return;
        const target = new URL(link.href, window.location.href);
        if (target.origin !== window.location.origin) return;
        campaignParams.forEach((value, key) => {
          if (!target.searchParams.has(key)) target.searchParams.append(key, value);
        });
        link.href = target.toString();
      });
    }

    const lists = Array.from(landing.querySelectorAll('[data-oahu-product-list]'));
    const listObserver = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        listObserver.unobserve(entry.target);
        sendProductListView(entry.target);
      });
    }, { threshold: .15 }) : null;
    const itemsFor = (list) => Array.from(list.querySelectorAll('[data-product-card]')).map((card, index) => ({
      item_id: card.dataset.productVariantId || card.dataset.productId,
      item_name: card.dataset.productTitle,
      index,
      item_list_id: list.dataset.oahuProductList,
      item_list_name: list.dataset.oahuListName,
      price: Number(card.dataset.productPrice || 0) / 100,
      quantity: 1
    }));
    const sendProductListView = (list, attempt = 0) => {
      if (list.dataset.productListViewSent === 'true') return;
      if (typeof window.gtag !== 'function') {
        if (attempt < 12) window.setTimeout(() => sendProductListView(list, attempt + 1), 250);
        return;
      }
      const items = itemsFor(list);
      if (!items.length) return;
      list.dataset.productListViewSent = 'true';
      window.gtag('event', 'view_item_list', {
        item_list_id: list.dataset.oahuProductList,
        item_list_name: list.dataset.oahuListName,
        items
      });
    };
    lists.forEach((list) => {
      if (listObserver) listObserver.observe(list);
      else sendProductListView(list);
      list.querySelectorAll('[data-product-card]').forEach((card, index) => {
        card.addEventListener('click', (event) => {
          if (!event.target.closest('a[href]') || typeof window.gtag !== 'function') return;
          window.gtag('event', 'select_item', {
            item_list_id: list.dataset.oahuProductList,
            item_list_name: list.dataset.oahuListName,
            items: [itemsFor(list)[index]]
          });
        }, { once: true });
      });
    });

    landing.querySelectorAll('[data-oahu-shelf]').forEach((shelf) => {
      const row = shelf.querySelector('[data-oahu-shelf-row]');
      const previous = shelf.querySelector('[data-oahu-shelf-prev]');
      const next = shelf.querySelector('[data-oahu-shelf-next]');
      const update = () => {
        previous.disabled = row.scrollLeft <= 2;
        next.disabled = row.scrollLeft + row.clientWidth >= row.scrollWidth - 2;
      };
      let frame = 0;
      const scheduleUpdate = () => {
        if (frame) return;
        frame = requestAnimationFrame(() => { frame = 0; update(); });
      };
      const move = (direction) => {
        const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        row.scrollBy({ left: direction * row.clientWidth * .85, behavior });
      };
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      row.addEventListener('scroll', scheduleUpdate, { passive: true });
      window.addEventListener('resize', scheduleUpdate, { passive: true });
      update();
    });

    const rating = landing.querySelector('[data-oahu-rating]');
    const count = landing.querySelector('[data-oahu-review-count]');
    const feed = landing.dataset.reviewFeed;
    if (rating && count && feed) {
      fetch(feed, { headers: { Accept: 'application/json' } })
        .then((response) => {
          if (!response.ok) throw new Error('Review feed unavailable');
          return response.json();
        })
        .then((data) => {
          if (!data || !data.rating || !data.userRatingCount) return;
          rating.textContent = `${Number(data.rating).toFixed(1)} on Google`;
          count.textContent = `· ${data.userRatingCount} reviews`;
        })
        .catch(() => {});
    }

    const sticky = landing.querySelector('[data-oahu-sticky]');
    const productAreas = Array.from(landing.querySelectorAll('[data-oahu-products], [data-oahu-shelf]'));
    const updateStickyVisibility = () => {
      if (!sticky || !productAreas.length || window.innerWidth > 760) return;
      const shouldStayClear = window.scrollY < 80 || productAreas.some((area) => {
        const bounds = area.getBoundingClientRect();
        return bounds.top < window.innerHeight * .85 && bounds.bottom > 0;
      });
      sticky.classList.toggle('is-hidden', shouldStayClear);
    };
    updateStickyVisibility();

    const updateStickyClearance = () => {
      if (!sticky || window.innerWidth > 760) return;
      let clearance = 142;
      document.querySelectorAll('shopify-chat, iframe[title*="chat" i], iframe[src*="inbox" i], [id*="shopify-chat" i], [class*="shopify-chat" i], [aria-label*="chat" i], [id*="shopify-pc__banner" i], [class*="shopify-pc__banner" i]').forEach((element) => {
        if (element === sticky || element.contains(sticky)) return;
        const rect = element.getBoundingClientRect();
        if (rect.height > 0 && rect.bottom >= window.innerHeight - 8 && rect.top > window.innerHeight * .35) {
          clearance = Math.max(clearance, Math.ceil(window.innerHeight - rect.top + 12));
        }
      });
      sticky.style.setProperty('--oahu-sticky-bottom', `${clearance}px`);
    };
    updateStickyClearance();
    let stickyFrame = 0;
    const scheduleStickyUpdate = () => {
      if (stickyFrame) return;
      stickyFrame = window.requestAnimationFrame(() => {
        stickyFrame = 0;
        updateStickyVisibility();
        updateStickyClearance();
      });
    };
    window.addEventListener('scroll', scheduleStickyUpdate, { passive: true });
    window.addEventListener('resize', scheduleStickyUpdate, { passive: true });
    window.setTimeout(updateStickyClearance, 800);
    window.setTimeout(updateStickyClearance, 2500);
  };

  document.querySelectorAll('[data-oahu-delivery-landing]').forEach(initOahuDeliveryLanding);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-oahu-delivery-landing]').forEach(initOahuDeliveryLanding);
  });

  } catch(e) { console.error(e); }
})();
})();
